import { useEffect, useRef } from "react";

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

interface AdBannerProps {
  slot: string;
  format?: "auto" | "rectangle" | "horizontal" | "vertical";
  className?: string;
  isPaid?: boolean;
}

export function AdBanner({ slot, format = "auto", className = "", isPaid }: AdBannerProps) {
  const adRef = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (isPaid || pushed.current) return;

    const pubId = import.meta.env.VITE_ADSENSE_PUB_ID;
    if (pubId && !document.querySelector('script[src*="adsbygoogle"]')) {
      const script = document.createElement("script");
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${pubId}`;
      script.async = true;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      // AdSense not loaded yet
    }
  }, [isPaid]);

  if (isPaid) return null;

  const pubId = import.meta.env.VITE_ADSENSE_PUB_ID;
  if (!pubId) return null;

  return (
    <div className={`ad-container overflow-hidden rounded-xl border border-rule bg-card ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={pubId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      <p className="text-[10px] text-ink-muted text-center py-0.5 opacity-50">Ad</p>
    </div>
  );
}
